import { Injectable } from '@angular/core';
import { currency } from 'i2g-rosetta';
import { LocalizationService } from '../localization';
import { CalculatorService } from '../calculator';

export interface ICurrencyInfo {
  symbol: string;
  decimalDigits: number;
  code: string;
}

@Injectable({
  providedIn: 'root',
})
export class MoneyService {
  constructor(
    private _localizationService: LocalizationService,
    private _calculatorService: CalculatorService
  ) {}

  getCurrencyInfo(currencyCode: string = 'USD'): ICurrencyInfo {
    const currencyInfo = currency.getCurrency(currencyCode);

    if (currencyInfo) {
      return {
        symbol: currencyInfo.symbol || '',
        decimalDigits: currencyInfo.digits,
        code: currencyInfo.code,
      };
    } else {
      return null;
    }
  }

  formatInSuperUnit(
    amountInSubUnit: number,
    currencyCode: string = 'USD',
    locale: string = 'en_US'
  ): string {
    const superUnit = this.subToSuperUnit(amountInSubUnit, currencyCode);
    return this.format(superUnit, currencyCode, locale);
  }

  /**
   * Format a number to currency
   *
   * @param amount (should be in superunit format)
   * @param currencyCode - Currency code
   * @param locale user locale
   */
  format(
    amount: number,
    currencyCode: string = 'USD',
    locale: string = 'en_US'
  ): string {
    return this._format(amount, currencyCode, locale);
  }

  subToSuperUnit(amount: any, currencyCode: string) {
    return currency.subToSuperUnit(parseFloat(amount) || 0, currencyCode);
  }

  superToSubUnit(amount: any, currencyCode: string) {
    return currency.superToSubUnit(parseFloat(amount) || 0, currencyCode);
  }

  calculatePercentageAmount(amount: number, percentage: number) {
    const amountPlusPercentage = this._calculatorService.percentageWithRounding(
      amount,
      percentage
    );
    return amountPlusPercentage - amount;
  }

  private _format(
    amount: number,
    currencyCode: string = 'USD',
    locale: string = 'en_US'
  ): string {
    const formattedLocale = this._localizationService.getFormattedLocale(
      locale
    );

    try {
      const formatter = global.Intl.NumberFormat(formattedLocale, {
        style: 'currency',
        currency: currencyCode,
      });

      return formatter.format(amount);
    } catch (e) {
      console.error(e);

      return '';
    }
  }
}
